import { Archive, ArchiveRestore, FolderOpen, SearchX } from "lucide-react";
import type { SidebarEmptyStateLook, SidebarEmptyStateVariant } from "./types";

export const SIDEBAR_EMPTY_STATE_LOOK_BY_VARIANT: Record<
  SidebarEmptyStateVariant,
  SidebarEmptyStateLook
> = {
  noPlans: {
    Icon: FolderOpen,
    circleClassName: "bg-gray-100",
    iconClassName: "text-gray-400",
    titleKey: "smartSurveyor.planFilter.noPlans",
    hintKey: "smartSurveyor.planFilter.noPlansHint",
  },
  noActivePlans: {
    Icon: ArchiveRestore,
    circleClassName: "bg-gray-100",
    iconClassName: "text-gray-400",
    titleKey: "smartSurveyor.planFilter.noActivePlans",
    hintKey: "smartSurveyor.planFilter.noActivePlansHint",
  },
  noArchivedPlans: {
    Icon: Archive,
    circleClassName: "bg-amber-50",
    iconClassName: "text-amber-500",
    titleKey: "smartSurveyor.planFilter.noArchivedPlans",
    hintKey: "smartSurveyor.planFilter.noArchivedPlansHint",
  },
  noSearchResults: {
    Icon: SearchX,
    circleClassName: "bg-gray-100",
    iconClassName: "text-gray-400",
    titleKey: "smartSurveyor.sidebarSearch.noResults",
    hintKey: "smartSurveyor.sidebarSearch.noResultsHint",
  },
};
